export const keywordsAndTopicsDefaultPageSize = 25;
export const keywordsAndTopicsPageSizeOptions: [number, ...Array<number>] = [10, 25, 50, 100];
